import React, { useState } from 'react';
import {
  ApiButton,
  Box,
  Button,
  CustomSelect,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  HeaderInput,
  Typography,
} from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import {
  useGetExamLevels,
  usePostCheckExamLevel,
} from '../../api/candidate/exam/@coordinator/queries-services/queries';
import { ExamLevelChecking } from '../../api/candidate/exam/model';

const useStyles = makeStyles()((theme) =>
({
  customClass: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  buttonContainer: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  errString: {
    color: theme.color.state.stateError,
  },
}));

interface SelectExamLevelModalProps {
  handleProceed: (examLevel: string) => void;
  examRegistrationType: string;
  modalState: boolean;
  onDialogClose: () => void;
}

const SelectExamLevelModal = ({
  handleProceed,
  examRegistrationType,
  modalState,
  onDialogClose,
}: SelectExamLevelModalProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const [examLevel, setExamLevel] = useState<string>();
  const [examLevelChecking, setExamLevelChecking] = useState<ExamLevelChecking>();
  const [error, setError] = useState('');

  const { data: menuItems } = useGetExamLevels();
  const postCheckExamLevel = usePostCheckExamLevel(
    () => {
      if (examLevel) {
        handleProceed(examLevel);
      }
    },
    (err) => {
      setError(err.response?.data.message!);
    }
  );

  const handleSelectChange = (examType: string) => {
    setExamLevel(examType);
    setExamLevelChecking({ examType, examRegistrationType });
    setError('');
  };

  const handleProceedClick = () => {
    if (examLevelChecking) {
      postCheckExamLevel.mutate(examLevelChecking);
    }
  };

  return (
    <Dialog open={modalState} onClose={onDialogClose} maxWidth="md">
      <DialogTitle>{t('withdrawal->>Coordinator.SelectExamLevel.Title')}</DialogTitle>
      <DialogContent>
        {menuItems && (
          <HeaderInput
            label={t('withdrawal->>Coordinator.SelectExamLevel.ExamLevel')}
            input={
              <CustomSelect
                id="input-select-group-withdrawal-exam-level"
                placeholder="Select Exam Level"
                displayEmpty
                onChange={({ target: { value } }) => handleSelectChange(value as string)}
                menuItems={menuItems}
                value={examLevel}
              />
            }
          />
        )}
        {error && (
          <Typography id="error-msg" variant="body2" color="error">
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Box className={classes.buttonContainer}>
          <Button id="button-cancel-select" onClick={onDialogClose} variant="text">
            {t('withdrawal->>Coordinator.SelectExamLevel.Cancel')}
          </Button>
          <ApiButton
            status={postCheckExamLevel.status}
            type="button"
            disabled={!examLevelChecking || !!error}
            onClick={handleProceedClick}
            id="button-proceed-select-exam-level"
          >
            {t('withdrawal->>Coordinator.SelectExamLevel.Proceed')}
          </ApiButton>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default SelectExamLevelModal;
